import el from "@cypherpotato/el";
import { Button } from "./button";
import { TextInput } from "./form";
import { Icon } from "./icon";

export function ListPickerControl({ value, validateItem, placeholder = "Add item", ariaLabel = placeholder, itemName = "item", includePendingValue = false, allowEmptyItems = false, allowDuplicateItems = false }) {

    const items = el.state.create(value);
    let input;

    return el(".list-picker",
        {
            $properties: {
                value: {
                    get() {
                        const pendingValue = input.value;
                        return includePendingValue && pendingValue.length > 0
                            ? [...items.value, pendingValue]
                            : items.value;
                    },
                    set(value) {
                        items.value = value;
                    }
                }
            }
        },
        el.state.listening([items], () =>
            el("div.list-picker-items",
                items.value.map((item, index) => el(
                    "div.list-picker-item",
                    el("div.list-picker-item-content",
                        item
                    ),
                    Button(Icon("delete-bin-7-line"), {
                        ariaLabel: `Remove ${itemName} ${index + 1}`,
                        onClick() {
                            items.value = items.value.filter((_, itemIndex) => itemIndex !== index);
                        }
                    })
                ))
            )
        ),
        el(".list-picker-input",
            input = TextInput(null, placeholder, {
                ariaLabel,
                onKeyDown(event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        event.stopPropagation();
                        
                        const value = event.target.value;
                        if (!allowEmptyItems && value.trim().length === 0) {
                            event.target.value = "";
                            return;
                        }
                        if (!allowDuplicateItems && items.value.includes(value)) {
                            event.target.classList.add("invalid");
                            event.target.focus();
                            return;
                        }

                        var isValid = true;
                        if (validateItem)
                            isValid = validateItem(value);

                        if (isValid) {
                            items.value.push(value);
                            items.requestUpdate();
                            event.target.value = "";
                            event.target.classList.remove("invalid");

                        } else {
                            event.target.classList.add("invalid");
                            event.target.focus();
                        }
                    }
                }
            })
        )
    )
}
